export const errorTypeDef = `
  message
  type
  attribute
`;
